import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { storage } from "../firebase";

const DEFAULT_MAX_BYTES = 10 * 1024 * 1024;

const IMAGE_MIME = new Set([
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
]);

const sanitizeExtension = (fileName) => {
  const base = (fileName || "").split(/[/\\]/).pop() || "file";
  const match = base.match(/(\.[a-zA-Z0-9]{1,8})$/);
  return match ? match[1].toLowerCase() : "";
};

/**
 * Upload a file to Firebase Storage under `folder/` with a UUID object name.
 * Validates MIME type and size before upload.
 */
export const uploadAdminAsset = (
  folder,
  file,
  {
    allowedMimeTypes = IMAGE_MIME,
    maxBytes = DEFAULT_MAX_BYTES,
    onProgress,
  } = {}
) => {
  if (!file) {
    return Promise.reject(new Error("No file selected"));
  }
  if (!allowedMimeTypes.has(file.type)) {
    return Promise.reject(
      new Error("File type not allowed. Use JPEG, PNG, GIF, or WebP.")
    );
  }
  if (file.size > maxBytes) {
    return Promise.reject(
      new Error(`File is too large (max ${Math.round(maxBytes / 1024 / 1024)}MB).`)
    );
  }

  const ext = sanitizeExtension(file.name);
  const objectPath = `${folder}/${uuidv4()}${ext}`;
  const storageRef = ref(storage, objectPath);
  const uploadTask = uploadBytesResumable(storageRef, file, {
    contentType: file.type,
  });

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        if (onProgress) {
          const pct =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(pct, snapshot.state);
        }
      },
      reject,
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(resolve).catch(reject);
      }
    );
  });
};
